import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { LockOutlined, ScheduleOutlined } from "@mui/icons-material";
import { debug } from "../utils";
import { showDangerToast, showSuccessToast } from "../validation/ToastContainer";
import { createOTP, setupTokenOnly, setSessionOtp, sendOtpToMail } from "./authService";

function OTPPage({referer, access_token, userMail}) {

    const [otp, _setOTP] = useState("");
    const [redirectToDashboard, setRedirectToDashboard] = useState(false);
    //const [tempToken, setTempToken] = useState();
    // const [isResending, setIsResending] = useState(false);

    // in document event listener react state is not accessible. We need to create refs
    const otpRef = React.useRef(otp);

    const setOtp = data => {
        otpRef.current = data;
        _setOTP(data);
    };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                // Use the ref to get the current value of OTP
                if (otpRef.current) {
                    handleSubmit();
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        // Cleanup function to remove the listener
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };

        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);


    const resendOTP = () => {  
        setRedirectToDashboard(false); 
        setOtp("");              
        createOTP()
            .then(otp => {
                sendOtpToMail(otp, userMail);
                setSessionOtp(otp);
                showSuccessToast("New OTP resent!", "Resend OTP");
            })
            .catch(error => {
                showDangerToast("Failed to resend OTP. Please try again.", "Resend OTP Error");
            });

    }

    // const resendOTP_aw = async () => {
    //     if (isResending) return; // Prevent multiple clicks
        
    //     setIsResending(true);
    //     try {
    //         const otp = await createOTP();
    //         sendOtpToMail(otp, userMail);
    //         setSessionOtp(otp);
    //         showSuccessToast("New OTP resent!", "Resend OTP");
    //     } catch (error) {
    //         console.error("Error resending OTP:", error);
    //         showDangerToast("Failed to resend OTP. Please try again.", "Resend OTP Error");
    //     } finally {
    //         setIsResending(false);
    //     }
    // }
    
    useEffect(() => { 
        async function checkSendOTP(){ 
            if(userMail) {           
                await createOTP().then(otp => {
                    sendOtpToMail(otp, userMail);
                    setSessionOtp(otp);                    
                });
            }  
        }  
        
        checkSendOTP();
                 
    }, [userMail]);
    
    const handleSubmit = () => {        
        if (otp) {
            const otp_date = sessionStorage.getItem('otp_date')
            const currentTime = Math.floor(Date.now() / 1000);
            const otpExpiry = Math.floor((currentTime - otp_date) / 60);
           if (sessionStorage.getItem('otp') === otp && otpExpiry <= 5) {
                setupTokenOnly(access_token, false);
                showSuccessToast("Successfully signed in", "Sign in");
                //addToken(tempToken);
                setRedirectToDashboard(true);
            }
            else {
                if (otpExpiry > 5) {
                    showDangerToast("OTP Provided is Expired. Please try again", "Sign in failure");
                    setOtp("");
                }
                else {
                    showDangerToast("Invalid OTP. Please try again", "Sign in failure");
                    setOtp("");   
                }
                
             }
            
        }
    }
 
    //#region Commented Code
    // useEffect(() => {
    //     if (access_token) {
    //         setTempToken(access_token);
    //         eraseTokenWithoutOTP();            
    //     }

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    // const [tokenErased, setTokenErased] = useState(false);
    // useEffect(() => {
    //     if (access_token && !tokenErased) {
    //         setTempToken(access_token);
    //         eraseTokenWithoutOTP();
    //         setTokenErased(true);
    //     }
    // }, [access_token, tokenErased]);
    //#endregion


    
    if (redirectToDashboard) {
        if (sessionStorage.getItem('otp') === otp) {
             return <Redirect to={referer || "/"} />;
         }        
     }

     return (
        <div className="hold-transition login-page-v2">
            <div className="decorative-background-v2">
                <div className="decorative-circle-v2 circle-1"></div>
                <div className="decorative-circle-v2 circle-2"></div>
            </div>

            <div className="login-container-v2">
                <div className="login-card-v2 otp-card-auth-v2">
                    <div className="logo-container-v2">
                        <img src={`${process.env.PUBLIC_URL}/octopus-logo.svg`} alt="Octopus Cybersecurity" className="logo-img-v2" />
                    </div>

                    <div className="login-header-v2">
                        <h2>Octopus VAR</h2>
                    </div>

                    <div className="otp-intro-v2">
                        <h3>Multi-Factor Authentication</h3>
                        <p>Please provide the OTP sent to your email.</p>
                    </div>

                    <div className="otp-meta-v2">
                        <ScheduleOutlined className="otp-meta-icon-v2" />
                        <span>Expires within 5 minutes</span>
                    </div>

                    <div className="login-form-v2">
                        <div className="form-group-v2">
                            <label htmlFor="otp">
                                OTP<span className="required-star">*</span>
                            </label>
                            <div className="input-wrapper-v2">
                                <div className="icon-wrapper-v2">
                                    <LockOutlined className="login-icon" />
                                </div>
                                <input
                                    id="otp"
                                    type="text"
                                    className="form-control-v2 otp-input-v2"
                                    placeholder="Enter OTP *"
                                    value={otp}
                                    inputMode="numeric"
                                    autoComplete="one-time-code"
                                    onChange={event => setOtp(event.target.value)}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={!otp}
                            className={`btn-login-v2 ${!otp ? 'btn-disabled' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                        >
                            Continue
                        </button>

                        <button
                            type="button"
                            className="otp-secondary-action-v2"
                            onClick={() => {
                                resendOTP();
                            }}
                        >
                            Resend OTP
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

}

function mapStateToProps(state) {
    debug("OTPPage mapStateToProps", state);
    return {
        access_token: state.auth.access_token,
        referer: state.auth.referer,
        userMail: state.auth.email
     };
}

export default connect(mapStateToProps)(OTPPage);
